import _ from "lodash";
import { localSearch } from "Utils";

export const SCHOOL_DEPENDENT_FILTERS = [
  "grades",
  "subjects",
  "learningCourses",
  "classes",
  "departments",
  "levels",
  "terms",
];

export const getSelectedFilterCount = ({ optionKeys, selectedOptions }) => {
  let count = 0;
  _.forEach(optionKeys, key => {
    if (_.isArray(selectedOptions[key]) && _.size(selectedOptions[key])) {
      count++;
    }
  });
  return count;
};

export const getFilteredOptionsBySchool = ({ options, selectedSchools }) => {
  const allSchoolOptions = _.get(options, "curriculumProgramIds.options", []);
  const shouldFilterBySchool =
    !_.isEmpty(selectedSchools) &&
    _.size(selectedSchools) < _.size(allSchoolOptions);

  if (!shouldFilterBySchool) return options;

  return _.mapValues(options, (filterData, key) => {
    if (!_.includes(SCHOOL_DEPENDENT_FILTERS, key)) return filterData;

    return {
      ...filterData,
      options: _.filter(filterData.options, opt =>
        _.includes(selectedSchools, opt.curriculumProgramId)
      ),
    };
  });
};

export const buildFlatItemsList = ({
  filteredOptions,
  selectedFilter,
  searchText,
  showSectionHeaders,
}) => {
  const currentOptions = _.get(
    filteredOptions,
    `${selectedFilter}.options`,
    []
  );

  const searchFiltered = _.isEmpty(searchText)
    ? currentOptions
    : _.filter(
        currentOptions,
        opt =>
          opt.isSectionHeader ||
          localSearch({ text: opt.label, searchText }) > -1
      );

  const items = _.reduce(
    searchFiltered,
    (result, option, index) => {
      if (option.isSectionHeader) {
        if (!showSectionHeaders) return result;

        const hasVisibleChildren = _.some(
          searchFiltered,
          child =>
            !child.isSectionHeader &&
            child.curriculumProgramId === option.curriculumProgramId
        );
        if (!hasVisibleChildren) return result;

        if (!_.isEmpty(result)) {
          result.push({ type: "separator", key: `sep-${index}` });
        }

        const sectionValues = _.map(
          _.filter(
            currentOptions,
            child =>
              !child.isSectionHeader &&
              child.curriculumProgramId === option.curriculumProgramId
          ),
          "value"
        );
        result.push({
          type: "sectionHeader",
          ...option,
          key: `header-${index}`,
          sectionValues,
        });
      } else {
        result.push({
          type: "checkbox",
          ...option,
          key: `item-${option.value}-${option?.curriculumProgramId || ""}`,
        });
      }
      return result;
    },
    []
  );

  const showAllCheckbox = _.isEmpty(searchText) && !_.isEmpty(items);
  if (showAllCheckbox) {
    items.unshift({ type: "all", key: "all" });
  }

  return items;
};
